<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="开始日期">
                    <el-date-picker
                      v-model="dialogViewForm.startDateStr"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="结束日期">
                    <el-date-picker
                      v-model="dialogViewForm.endDateStr"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="填报日期">
                    <el-date-picker
                      v-model="dialogViewForm.reportDateStr"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              投放订购信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="tobaccoListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="tobaccoName"
                      label="名称"
                    />
                    <el-table-column
                      prop="putAmount"
                      label="投放量"
                    />
                    <el-table-column
                      prop="demandAmount"
                      label="需求量"
                    />
                    <el-table-column
                      prop="orderAmount"
                      label="订购量"
                    />
                    <el-table-column
                      prop="orderRate"
                      label="订足率"
                    />
                    <el-table-column
                      prop="satisfyRate"
                      label="订单满足率"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              操作备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="操作人">
                    <el-input
                      v-model="dialogViewForm.operatorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="操作时间">
                    <el-input
                      v-model="dialogViewForm.operationTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="状态">
                    <el-input
                      v-model="dialogViewForm.statusStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:-10px;"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { initSupplyUseEfficiencyInfoApi } from '@/api/supplyUseEfficiencyInfo'
export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      dialogViewForm: {
      },
      tobaccoListData: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.tobaccoListData = []
        this.loading = true
        this.dialogViewForm = {
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          startDateStr: '',
          endDateStr: '',
          reportDateStr: '',
          operatorName: '',
          operationTimeStr: '',
          statusStr: '',
          remark: ''
        }
        this.initData()
      }
    }
  },
  methods: {
    // 加载数据
    initData() {
      initSupplyUseEfficiencyInfoApi({ id: this.dataId }).then(res => {
        const { bill, detailList } = res.data
        for (let key in this.dialogViewForm) {
          this.dialogViewForm[key] = bill[key]
        }
        this.dialogViewForm.id = bill.id
        detailList.forEach(item => {
          item.orderRate = item.orderRate + '%'
          item.satisfyRate = item.satisfyRate + '%'
        })
        this.tobaccoListData = detailList
        this.loading = false
      })
    },

    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
.demo-input-suffix {
  padding: 10px 0;
  .el-input {
    margin-right: 10px;
    width: 120px;
  }
  .title-sp {
    color: #1a9bff;
    margin-right: 10px;
  }
}
</style>
